import {
  CANCEL_SPECIALIST_INVITATION,
  CANCEL_SPECIALIST_INVITATION_FAILURE,
  CANCEL_SPECIALIST_INVITATION_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const cancelSpecialistInvitationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANCEL_SPECIALIST_INVITATION:
      return { ...state, loading: true };
    case CANCEL_SPECIALIST_INVITATION_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case CANCEL_SPECIALIST_INVITATION_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default cancelSpecialistInvitationReducer;
